<template>
  <a-modal
    title="编辑"
    width="500px"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-card :body-style="{padding: '2px 2px'}" :bordered="false">
      <a-spin :spinning="spinning">
        <a-form :form="form">

          <a-form-item
            label="头像"
            :labelCol="{lg: {span: 6}, sm: {span: 7}}"
            :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
            <a-avatar :src="user_avatar" icon="user" size="middle" shape="circle" />
          </a-form-item>

          <a-form-item
            label="用户名"
            :labelCol="{lg: {span: 6}, sm: {span: 7}}"
            :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
            <span style="padding-left:10px" >{{ `${user_name}` }}</span>
          </a-form-item>

          <a-form-item
            label="用户昵称"
            :labelCol="{lg: {span: 6}, sm: {span: 7}}"
            :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
            <a-input
              placeholder="请输入用户昵称"
              v-decorator="[ 'user_nickname']"
              />
          </a-form-item>

          <a-form-item
            label="手机号"
            :labelCol="{lg: {span: 6}, sm: {span: 7}}"
            :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
            <a-input
              placeholder="请输入用户手机号码"
              v-decorator="[ 'user_mobile']"
               />
          </a-form-item>

          <a-form-item
            label="QQ"
            :labelCol="{lg: {span: 6}, sm: {span: 7}}"
            :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
            <a-input
              placeholder="请输入用户QQ号码"
              v-decorator="[ 'user_qq' ]"
               />
          </a-form-item>

          <a-form-item
            label="邮箱"
            :labelCol="{lg: {span: 6}, sm: {span: 7}}"
            :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
            <a-input
              placeholder="请输入用户邮箱"
              v-decorator="[ 'user_mail']"
              />
          </a-form-item>

          <a-form-item
            label="备注信息"
            :labelCol="{lg: {span: 6}, sm: {span: 7}}"
            :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
            <a-input
              placeholder="请输入用户备注信息"
              v-decorator="[ 'user_comments']"
              />
          </a-form-item>

        </a-form>

      </a-spin>
    </a-card>
  </a-modal>
</template>

<script>
import { editUserInfo } from '@/api/user'
import AvatarEdit from '@/components/AvatarEdit'

export default {
  name: 'EditUserInfoModal',
  components: {
    AvatarEdit
  },
  data () {
    return {
      visible: false,
      form: this.$form.createForm(this),
      spinning: false,
      user_uid: '',
      user_avatar: '',
      user_name: '',
    }
  },

  methods: {
    edit () {
      const user = this.$store.getters.userInfo
      this.spinning = true
      this.visible = true
      this.user_uid = user.uid,
      this.user_name = user.user_name
      this.user_avatar = user.user_avatar
      this.form.resetFields()
      const _this = this
      this.$nextTick(() => {
        _this.form.setFieldsValue({
          user_nickname: user.user_nickname,
          user_comments: user.user_comments,
          user_mobile: user.user_mobile,
          user_qq: user.user_qq,
          user_mail: user.user_mail
        })
        _this.$nextTick(() => {
          _this.spinning = false
        })
      })
    },
    handleCancel () {
      this.visible = false
    },
    handleOk () {
      const _this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            user_nickname: values.user_nickname,
            user_comments: values.user_comments,
            user_mail: values.user_mail,
            user_qq: values.user_qq,
            user_mobile: values.user_mobile
          }
          editUserInfo(params).then(res => {
            if(res.code!=200){
              throw ''
              return
            }
            _this.$message.success('修改成功')
            _this.$emit('userInfoChanged')
            _this.visible = false
          }).catch((err) => {
            _this.$message.error('修改失败')
          })
        }
      })
    },
    handleUpload () {
      const uid = data.file.uid
      const formData = new FormData()
      const _this = this

      formData.append('file', data.file)
      formData.append('fastdfs_token', this.FDStoken)

      axios({
        method: 'post',
        url: '/fastdfs/upload',
        data: formData,
        timeout: 1000 * 60 * 2,
        onUploadProgress: event => {
          var index = _this.indexOf(uid)
          if (index == -1) return
          if (!_this.fileList[index]) return
          _this.$set(_this.fileList[index], 'percent', event.loaded / event.total)
        }
      }).then(res => {
        var index = _this.indexOf(uid)

        if (index == -1) return
        _this.$set(_this.fileList[index], 'status', 'done')
        _this.$set(_this.fileList[index], 'name', res.data.filename)
        _this.$set(_this.fileList[index], 'url', res.data.fileurl)
        _this.$set(_this.fileList[index], 'fileUid', res.data.fileUid)
        _this.$emit('upload_done')
      }).catch(err => {
        var index = _this.indexOf(uid)
        if (index == -1) return
        _this.$set(_this.fileList[index], 'status', 'error')
      })
    }
  }
}
</script>
